import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import { Typography } from '@mui/material';
import Stack from '@mui/material/Stack';
import { useTranslation } from 'react-i18next';
import OfficeSwitcher from '../../settings/modals/OfficeSwitcher';

export default function InviteAcceptedModal({ userInvite = null, open, onClose }) {
    const { t } = useTranslation('common'); 

    const handleCancel = () => {
        onClose();
    };

    return (
        <>
        <Dialog 
          onClose={(event, reason) => {
            if (reason !== "backdropClick") {
              handleCancel();
            }
          }}
          disableEscapeKeyDown
          open={open} 
          disableRestoreFocus
        >

        <DialogTitle>Account Acctivated!</DialogTitle>

        <DialogContent dividers>
          <Stack spacing={1}>
            <Typography variant="body1">
              You are now part of the{' '}
              <Typography component="span" variant="body2" fontWeight="bold">
                {userInvite.office.name}
              </Typography>{' '}
              team.
            </Typography>

            <Typography variant='body1'>Switch from one clinic/branch to another at any time.</Typography>
            <Typography variant='body1'>Would you like to switch to your new clinic/branch now?</Typography>
            <OfficeSwitcher 
              onClose={handleCancel}
            />
            <Button 
              variant='outlined' 
              fullWidth
              onClick={handleCancel}
            >
              Switch Later
            </Button>
          </Stack>
        </DialogContent>

        </Dialog>
        </>
    );
}